import type { CategoryWithVods } from '@setplex/tria-api'
import type { Store } from 'effector'
import type { VodWithPrice } from '~/shared/interfaces'

import { api } from '@setplex/tria-api'
import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { extendMediaItemByLabelPrice } from '~/shared/tools'

export interface CategoryWithVodsFormatted extends CategoryWithVods {
  content: VodWithPrice[]
  nameFormatted: string // 'Drama Genres'
}

export const $categoriesWithVodsFormattedVods: Store<
  CategoryWithVodsFormatted[] | null
> = combine(
  api.vods.$categoriesWithVods,
  ssePurchasesModel.$vod,
  i18n.$t,
  (content, adjust, { t }) => {
    if (content?.length === 0) return null
    return content
      .map((category) => {
        const vods = category.content.map(
          (vod) => extendMediaItemByLabelPrice(adjust(vod)) as VodWithPrice
        )
        const genresText = t('genre_other')
        return {
          ...category,
          content: vods,
          nameFormatted: `${category.name} ${genresText}`,
        }
      })
      .sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder))
  }
)
